import { createSlice } from '@reduxjs/toolkit'
import {
    fetchAuthByCode,
    fetchCheckSession,
    fetchLogin,
    fetchUpdateNotificationFlag,
    fetchUpdateNotificationTime
} from './extraReducers'
import { convertHoursToTime } from '../../common/utils/user'

const slice = createSlice({
    name: 'global',
    initialState: {
        user: null as any,
        isLoadingLogin: true,
        error: null as string | null
    },
    reducers: {
        setUserRoutine: (state, action) => {
            state.user = action.payload
        },
        setUserPhotoIdRoutine: (state, action) => {
            state.user.photoId = action.payload
        },
        setLoadingRoutine: (state, action) => {
            state.isLoadingLogin = action.payload
        },
        hideErrorRoutine: (state) => {
            state.error = null
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCheckSession.pending, (state) => {
                state.isLoadingLogin = true
                state.error = null
            })
            .addCase(fetchCheckSession.fulfilled, (state, action) => {
                state.user = action.payload
                state.isLoadingLogin = false
                state.error = null
            })
            .addCase(fetchCheckSession.rejected, (state, action) => {
                state.user = null
                state.isLoadingLogin = false
                // TODO: разобраться, как получать ошибку (сейчас она тут не возвращается)
                state.error = (action.payload as any)?.error
            })
            .addCase(fetchLogin.pending, (state) => {
                state.user = null
                state.isLoadingLogin = true
                state.error = null
            })
            .addCase(fetchLogin.fulfilled, (state, action) => {
                state.user = (action.payload as any).user
                state.isLoadingLogin = false
                state.error = null
            })
            .addCase(fetchLogin.rejected, (state) => {
                state.user = null
                state.isLoadingLogin = false
                state.error = 'Неверный логин или пароль'
            })
            .addCase(fetchAuthByCode.pending, (state) => {
                state.user = null
                state.isLoadingLogin = true
                state.error = null
            })
            .addCase(fetchAuthByCode.fulfilled, (state, action) => {
                state.user = (action.payload as any).user
                state.isLoadingLogin = false
                state.error = null
            })
            .addCase(fetchAuthByCode.rejected, (state) => {
                state.user = null
                state.isLoadingLogin = false
                state.error = 'Неверный логин или пароль'
            })
            .addCase(fetchUpdateNotificationFlag.fulfilled, (state) => {
                state.user.notificationFlag = !state.user.notificationFlag
            })
            .addCase(fetchUpdateNotificationTime.fulfilled, (state, action) => {
                state.user.notificationTime = convertHoursToTime((action.payload as any).time)
            })
    }
})

export const { setUserRoutine, setUserPhotoIdRoutine, setLoadingRoutine, hideErrorRoutine } = slice.actions
export const userSelector = (state: any) => state.global.user
export const errorSelector = (state: any) => state.global.error
export const premiumStatusSelector = (state: any) => state.global.user?.isPremium
export const loginLoadingSelector = (state: any) => state.global.isLoadingLogin
export default slice.reducer
